<app-confirmation-modal
  class="delete-appointment-modal"
  [visible]="visible"
  (visibleChange)="setVisible($event)"
  header="Confirm Cancellation"
  (onYes)="clickedOnYes()"
  (onCancel)="clickedOnNo()">
  Are you sure you want to cancel your <b>{{ appointmentStartDateTime }}</b> appointment at {{ address }}?
</app-confirmation-modal>